__turbopack_context__.v({
  "infoMessage": "RegistrationIdentityForm-module__5C0zea__infoMessage",
  "navButton": "RegistrationIdentityForm-module__5C0zea__navButton",
  "navigation": "RegistrationIdentityForm-module__5C0zea__navigation",
});
